import { AxiosResponse } from 'axios'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { getLatestNews } from 'src/services/api/WebApi/NewsModule/newsModule'
import { latestPostsFailure, latestPostsSuccess } from './latestNews.actions'
import { latestPostTypes } from './latestNews.types'

function* fetchLatestPostsSaga() {
  try {
    const response: AxiosResponse = yield call(getLatestNews)
    yield put(
      latestPostsSuccess({
        data: response.data
      })
    )
  } catch (err) {
    if (err instanceof Error) {
      yield put(latestPostsFailure({ error: err.message }))
    }
  }
}

function* latestPostsSaga() {
  yield all([takeLatest(latestPostTypes.POST_REQUEST, fetchLatestPostsSaga)])
}

export default latestPostsSaga
